







import {
  defineComponent,
  PropType,
} from '@nuxtjs/composition-api';
import { usePackagingUnit } from '~/composables/usePackagingUnit';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';

import type { CartItemInterface } from '@wemade-vsf/magento-api';

export default defineComponent({
  name: 'CartItemAdditionalInformation',
  props: {
    item: {
      type: Object as PropType<CartItemInterface>,
      required: true
    }
  },
  setup (props) {
    //@ts-ignore
    const { packageSize, getPackageUnit } = usePackagingUnit({ product: (props.item as CartItemInterface).product as Product });
    const total = packageSize.value ? packageSize.value * (props.item as CartItemInterface).quantity : 0;

    return {
      packageSize,
      total,
      unit: getPackageUnit()
    }
  }
})
